import React, { useMemo } from 'react';
import { func, string } from 'prop-types';
import { useSelector } from 'react-redux';
import Handouts from '../../Handouts';
import Loading from '../../Common/FullScreenLoader';

const SessionHandout = ({ webinarKey, close, ...props }) => {
  const handouts = useSelector(({ handouts: handoutsStore }) => handoutsStore);
  const handoutsLoaded = useMemo(
    () => handouts?.handoutsConstraints?.data?.allowedFileSizeInBytes ?? null,
    [handouts.handoutsConstraints.data.allowedFileSizeInBytes]
  );

  if (!handoutsLoaded) return <Loading showBackground={false} color="blue" />;
  return <Handouts onClose={close} webinarKey={webinarKey} handouts={handouts} {...props} />;
};

SessionHandout.propTypes = {
  webinarKey: string,
  close: func.isRequired
};

export default SessionHandout;
